import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../components/AppIcon';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // The AuthContext will handle the auth state change and redirect appropriately
    // This is just a loading page that shows while the OAuth flow completes
    const timer = setTimeout(() => {
      // If still on this page after 3 seconds, redirect to home
      navigate('/', { replace: true });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-50">
      <div className="text-center">
        <div className="flex items-center justify-center mb-6">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary"></div>
        </div>
        <h2 className="text-2xl font-heading font-bold text-text-primary mb-2">
          Completing Sign In...
        </h2>
        <p className="text-text-secondary font-caption">
          Please wait while we complete your authentication
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
